import { Adapter as n } from "../../../../adapter.js";
import { KioskConfigurationHomeModel as m, KioskConfigurationHomeMode as g } from "./kioskConfigurationHome.model.js";
class u extends n {
  adapt(e) {
    var o, i, r, s;
    return new m({
      design: {
        images: {
          background: ((i = (o = e == null ? void 0 : e.design) == null ? void 0 : o.images) == null ? void 0 : i.background) ?? []
        }
      },
      settings: {
        mode: ((r = e == null ? void 0 : e.settings) == null ? void 0 : r.mode) ?? g.TOTEM,
        sliderSpeed: ((s = e == null ? void 0 : e.settings) == null ? void 0 : s.slider_speed) ?? 5
      }
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  u as KioskConfigurationHomeAdapter
};
//# sourceMappingURL=kioskConfigurationHome.adapter.js.map
